import axios from '@/jslib/axios'

export const addClaimLog = data => {
  return axios({
    method: 'post',
    url: '/admin/claim/log/add',
    data
  })
}

export const editClaimLog = data => {
  return axios({
    method: 'post',
    url: '/admin/claim/log/edit',
    data
  })
}

export const deleteClaimLog = data => {
  return axios({
    method: 'delete',
    url: '/admin/claim/log/delete',
    data
  })
}

export const setClaimStatus = data => {
  return axios({
    method: 'put',
    url: '/admin/claim/status/set',
    data
  })
}
export const setInsurersClaim = data => {
  return axios({
    method: 'post',
    url: '/admin/insurers/claim/set',
    data
  })
}
export const getInsurersClaimDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/insurers/claim/detail',
    params
  })
}
